/* eslint-disable prettier/prettier, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call */
import * as gql from 'fake-tag';

export const GladlyFragment = {
  GHC: gql`
    fragment GladlyHCQuery on gladlyHelpCenter_Entry {
      gladlyBrandIdOverride
      showGladlyHelpCenter
      typeHandle
    }
  `,
};
